// action - state management
import { REGISTER, LOGIN, LOGOUT } from './actions';
import { cache } from 'swr/_internal';

function clearSwrCache() {
  // This will clear *all* SWR keys and their data
  cache.clear();
}
// initial state
const initialState = {
  isLoggedIn: false,
  isInitialized: false,
  isAuthenticated: false,
  user: null
};

// ==============================|| AUTH REDUCER ||============================== //

const auth = (state = initialState, action) => {
  switch (action.type) {
    case REGISTER: {
      const { user } = action.payload;
      return {
        ...state,
        user
      };
    }
    case LOGIN: {
      const { user } = action.payload;
      return {
        ...state,
        isLoggedIn: true,
        isInitialized: true,
        isAuthenticated: true,
        user
      };
    }
    case LOGOUT: {
      // logout
      clearSwrCache();
      return {
        ...state,
        isInitialized: true,
        isLoggedIn: false,
        isAuthenticated: false,
        user: null
      };
    }
    default: {
      return { ...state };
    }
  }
};

export default auth;
